<template>
  <el-dialog :title="title"  :visible.sync="dialogSeeVisible" center :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true" custom-class="max-dialog">
    <div style="width: 100%;margin-bottom: 20px">
      <el-radio v-model="saleserial" :key="item.erpserial" :label="item.erpserial" border v-for="(item,index) in order" @change="showItems">
        {{item.erpserial}} （{{item.handleoverdate}} &nbsp;{{item.logisticsco}}{{item.logisticsnum}}）
      </el-radio>
    </div>
    <el-col :span="6">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="color: #20A0FF">采购需求</span>
          <span style="padding-left: 20px">总数：{{goodsTotalnum}}</span>
        </div>
        <div style="line-height: 34px;">{{buyxuqiu}}</div>
        <el-table :data="tabledata" size="mini" stripe border  style="width:100%;" empty-text="门店未指定型号">
          <el-table-column
            width="50"
            label="序"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column
            prop="M"  align="left" header-align="center"   width="90" label="型号">
          </el-table-column>
          <el-table-column
            prop="C"  align="left" header-align="center"   width="55" label="色号">
          </el-table-column>
          <el-table-column
            prop="P"  align="left" header-align="center"   width="55" label="数量">
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
    <el-col :span="1">&nbsp;</el-col>
    <el-col :span="17">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="color: #20A0FF"><b>{{categoryname}}</b> &nbsp;&nbsp;实发商品</span>
          <span style="padding-left: 20px">总数：{{sendTotalnum}}</span>
          <span style="padding-left: 20px">总价：{{sendTotalmoney}}</span>
          <span style="padding-left: 100px">单号：</span>
          <el-input v-model="erpserial" size="mini" v-show="canedit&&ssotoken" placeholder="供应商单号" onfocus="this.select()" style="width: 180px"
                    @keyup.enter.native="afterLogin" ref="gysErpserial"></el-input>
          <span v-if="!(canedit&&ssotoken)">{{erpserial}}</span>
        </div>
        <el-table :data="sendData" size="mini" stripe border  style="width:100%;" empty-text="尚未发货">
        <el-table-column  width="50"  label="序"
          align="center">
          <template slot-scope="scope">
            {{1+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column
          prop="产品名称"  align="left" header-align="center"   width="300" label="产品名称">
        </el-table-column>
        <el-table-column
          prop="型号"  align="left" header-align="center"   width="120" label="型号">
        </el-table-column>
        <el-table-column
          prop="规格"  align="left" header-align="center"   width="80" label="色号">
        </el-table-column>
        <el-table-column
          prop="数量"  align="left" header-align="center"   width="80" label="数量">
        </el-table-column>
        <el-table-column
          prop="单价"  align="left" header-align="center"   width="80" label="单价">
        </el-table-column>
        <el-table-column
          prop="总价"  align="left" header-align="center"   width="100" label="合计">
        </el-table-column>
      </el-table>
      </el-card>
    </el-col>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close" size="medium">取 消</el-button>
      <el-button type="primary" @click="update" :loading="loading" v-if="sendData.length>0" size="medium">确认入库</el-button>
    </div>
  </el-dialog>
</template>

<script>
    import {getBySerial} from '@/api/set/externaldept';
    import {listSimple,buyodersavedetail,updateFastFrame} from '@/api/set/csagreement';
    import {login, listOrder,detailOrder} from '@/api/ossi';
    import {getRemark,loadSpecFrame} from '@/plugin/ordercommon';
    import {jingjiaupload} from '@/api/set/jxcgooddetail'
    import {isUGO} from '@/api/login';

    export default {
      name: "BuyfromFastCheckFrame",
      data() {
        return {
          title: '订单信息',
          loading: false,
          pcustomername: '',
          intiData: {},
          UGO:false,
          buyxuqiu: '',
          categorycode: '',
          categoryname: '',
          showlookprice: true,
          dialogSeeVisible: false,
          ssotoken: '',
          website: '',
          erpserial: '',
          pcustomerserial: '',
          userInfoModel: [],
          order: [],
          saleserial: '',
          buyitems: {},
          tabledata: [],
          sendData: [],
          goodsTotalnum: 0,
          sendTotalnum: 0,
          sendTotalmoney: 0,
          existotherorder: false,
          canedit: true,
        }
      },
      methods: {
        close() {
          this.dialogSeeVisible = false;
        },
        lookDetails(item) {
        },
        show(orderdata, buyitems) {
          this.intiData = orderdata;
          this.erpserial = orderdata.tracknum;
          this.pcustomerserial = orderdata.pcustomerserial;
          this.saleserial = '';
          this.loading = false;
          this.buyitems = buyitems ? buyitems[0] : null;
          this.sendData = [];
          this.sendTotalnum = 0;
          this.sendTotalmoney = 0;
          this.categoryname = '';
          this.categorycode = orderdata.seedinfo.split(';')[0];
          this.buyxuqiu = getRemark(orderdata.remark, null, '采购留言')
          if (this.erpserial && this.erpserial.length >= 14 && this.erpserial.substr(0, 2) == 42) {
            this.canedit = false;
            this.setOrderitem();//采购需求
          } else {
            this.categoryname = orderdata.categoryname ? orderdata.categoryname : '';
          }
          getBySerial({customerserial: this.pcustomerserial, unitgroup: '3'}).then(resCus => {
            if (resCus.data.code == 0 && resCus.data.obj.usesso == '1' && resCus.data.obj.ssocode) {
              this.pcustomername = resCus.data.obj.deptname;
              this.dialogSeeVisible = true;
              login({
                idencode: resCus.data.obj.ssocode,
                tenantid: this.userInfoModel.tenantid,
                independentserial: this.userInfoModel.independentserial
              }).then(loginres => {
                if (loginres.data.code == 0) {
                  this.ssotoken = loginres.data.msg;
                  this.website = loginres.data.website;
                  this.$nextTick(() => {
                    if (this.$refs.gysErpserial)
                      this.$refs.gysErpserial.focus();
                  })
                  this.afterLogin();
                } else {
                  this.$message({message: loginres.data.msg, type: 'error'})
                }
              });
            }
          });
        },
        afterLogin() {
          this.existotherorder = false;
          this.order = [];
          this.sendData = [];
          this.erpserial = this.erpserial ? this.erpserial.toString().trim() : '';
          if (!(this.erpserial && this.erpserial.length == 14 && this.erpserial.substr(0, 2) == 42)) {
            if (this.canedit && this.erpserial) {
              this.$message({message: '订单号输入错误！', type: 'error'})
            }
            return;
          }
          listOrder({erpserial: this.erpserial}, this.ssotoken).then(resOrder => {//供应商订单信息
            if (resOrder.data.code != 0) return;
            if (!this.canedit) {
              listSimple({notfilterindependent: "1", groupguid: this.buyitems.groupguid}).then(resBuy => {//所有采购单列表
                var fahuo = ';';
                for (let i in resBuy.data.obj) {
                  if (resBuy.data.obj[i].status == 820) {//同一批次 已收货的订单排除
                    fahuo += resBuy.data.obj[i].tracknum + ';';
                  }
                }

                for (let i in resOrder.data.obj.rows) {
                  var r = resOrder.data.obj.rows[i];
                  if ((r.status == 400 || r.status == 500) && fahuo.indexOf(';' + r.erpserial + ';') == -1) {//供应商已发货订单
                    if (this.saleserial == '')
                      this.saleserial = r.erpserial;
                    this.order.push(r);
                    break;//只接收一次 （后面再改）
                  } else {
                    if ((r.status == 200 || r.status == 350) && r.isreturnorder != -1)//存在未发货的订单
                      this.existotherorder = true;
                  }
                }
                if (this.order.length > 1) {//发了多次 都没签收的
                  this.existotherorder = true;
                }
                if (this.order.length == 0) {
                  this.$message({message: '供应商尚未发货！', type: 'error'})
                  this.dialogSeeVisible = false;
                } else {
                  this.showItems();
                }
              });
            }
            else {
              if (resOrder.data.obj && resOrder.data.obj.rows && resOrder.data.obj.rows.length > 0) {
                listSimple({notfilterindependent: "1", tracknumfix: this.erpserial}).then(resBuy => {//所有采购单列表
                  if (resBuy.data.obj.length > 0) {
                    this.$message({message: '订单已入库《' + resBuy.data.obj[0].erpserial + '》，请不要重复操作！', type: 'error'})
                    return;
                  }

                  var r = resOrder.data.obj.rows[0];
                  if (r.status == 400 || r.status == 500) {//供应商已发货订单
                    this.saleserial = r.erpserial;
                    this.showItems();
                  } else {
                    this.$message({message: '供应商尚未发货！', type: 'error'});
                  }
                });
              } else {
                this.$message({message: '订单号不存在！', type: 'error'});
              }
            }
          });
        },
        setOrderitem() {
          this.goodsTotalnum = 0;
          this.tabledata = [];
          if (!this.buyitems) return;
          for (let i in this.buyitems.billmap) {
            var buyGoods = this.buyitems.billmap[i];
            var row = {seedcode: "", seedname: "", M: "", C: "", P: 0};
            for (let j in buyGoods) {
              for (var key in buyGoods[j]) {
                switch (key) {
                  case "seedcode":
                    row.seedcode = buyGoods[j][key];
                    break;
                  case "产品名称":
                    row.seedname = buyGoods[j][key];
                    break;
                  case "型号":
                    row.M = buyGoods[j][key];
                    break;
                  case "规格":
                    row.C = buyGoods[j][key];
                    break;
                  case "数量":
                    if (row.seedname != '合计') {
                      row.P = parseInt(buyGoods[j][key]);
                      this.goodsTotalnum += row.P;
                    }
                    break;
                }
              }
            }
            if (row.seedname != '合计') {
              this.tabledata.push(row);
            }
          }
          this.tabledata.sort(function (a, b) {
            if (a.M == b.M)
              return a.C.localeCompare(b.C)
            else
              return a.M.localeCompare(b.M)
          })
        },
        showItems() {
          this.sendTotalnum = 0;
          this.sendTotalmoney = 0;
          detailOrder({erpserial: this.saleserial, pname: this.categoryname}, this.ssotoken).then(resOrder => {//供应商订单信息
            if (resOrder.data.code == 0) {
              this.sendData = resOrder.data.obj.goodsDetail;
              for (let i in this.sendData) {
                this.sendTotalnum += parseInt(this.sendData[i]['数量']);
                this.sendTotalmoney += parseFloat(this.sendData[i]['总价']);
              }
              this.sendTotalmoney = this.sendTotalmoney.toFixed(2);
            } else {
              this.$message({message: resOrder.data.msg, type: 'error'})
            }
          });
        },
        overOrder(arr) {
          updateFastFrame({
            unitguid: this.buyitems.unitguid,
            details: JSON.stringify(arr)
          }).then(resOrder => {
            if (resOrder.data.code == 0) {
              this.$emit('afterCheckIn');
              this.dialogSeeVisible = false;
            } else {
              this.$message({message: resOrder.data.msg, type: 'error'})
              this.loading = false;
            }
          });
        },
        afterLoadFrame(arr) {
          if (this.canedit) {
            var jxcforms = [{seedname: this.intiData.seedname, seedcode: this.intiData.seedcode, type: "category"}];
            var map = {
              pcustomerserial: this.intiData.pcustomerserial,
              pcustomer: this.intiData.pcustomer,
              cangkuname: this.intiData.cangkuname,
              cangkucode: this.intiData.cangkucode,
              address: "",
              linkman: "",
              linkmantel: "",
              seedcode: this.intiData.seedcode,
              seedname: this.intiData.seedname,
              seedinfo: this.intiData.seedcode + ";" + this.intiData.seedname,
              remark: this.intiData.remark,
              tracknum: this.erpserial,
              isdistribute: "80",
              logisticstracknum: "",
              invoicesource: 1,
              status: 810,
              seedcodelist: "nocode",
              barcodes: []
            };
            //生成新的订单
            buyodersavedetail({
              jxcforms: JSON.stringify(jxcforms),
              map: JSON.stringify(map)
            }).then(resOrder => {
              if (resOrder.data.code != 0) {
                this.$message({message: resOrder.data.msg, type: 'error'})
                return;
              }
              this.buyitems = {unitguid: resOrder.data.obj.unitguid};
              this.overOrder(arr);//将订单办结
            })
          } else {
            this.overOrder(arr);
          }
        },
        update() {
          var addTable = [];
          var arr = [];
          if (this.UGO) {
            for (let i in this.sendData) {
              var item = this.sendData[i];
              var model = item['型号'];
              if (model == null)
                model = "";
              model = model.replace(/ /g, "").toUpperCase().replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
              var color = (item['规格'] ? item['规格'] : (item['色号'] ? item['色号'] : '')).toUpperCase().replace(/ /g, "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");

              var row = {
                seedcode: item["seedcode"], minnumber: item["数量"], costprice: item["单价"],
                goodsframe: '[{"model":"' + model + '","color":"' + color + '"}]'
              };
              arr.push(row);
            }
            if (arr.length == 0) {
              return;
            }
            this.afterLoadFrame(arr);
          } else {
            for (let i in this.sendData) {
              var item = this.sendData[i];
              var row = {
                "型号": item["型号"], "规格": item["规格"], "数量": item["数量"], "商品名称": item["产品名称"],
                "供应商": this.pcustomername, "采购成本价": item["单价"]
              };
              if (this.UGO) {
                row.seedcode = item["seedcode"];
              }
              addTable.push(row);
            }
            arr = loadSpecFrame(addTable, this.categorycode, "", null);
            if (arr.length == 0) {
              return;
            }

            this.loading = true;

            jingjiaupload({needcode: 1, arr: JSON.stringify(arr)}).then(resPrice => {
              if (resPrice.data.code != 0) {
                return;
              }
              var returnSeed = resPrice.data.obj;
              if (returnSeed == null) return;

              for (let i in arr) {
                var item = arr[i];
                item.seedcode = returnSeed.find(row => row.goodsframe == item.goodsframe).seedcode;
              }
              this.afterLoadFrame(arr);
            });
          }
        },
      },
      mounted() {
        this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
        this.UGO=isUGO();
      },
      components: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyfromFastCheckFrame.vue